import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _ from 'lodash';
import React from 'react';
import classnames from 'classnames/bind';
import Text from '../../../elementals/text';
import Icon from '../../../elementals/icon';
import styles from '../styles.scss';
import ListingBadge, { BADGE_MODE, CondensedBadge } from './base';
const cx = classnames.bind(styles);
export default class FullWidthBadge extends ListingBadge {
    render() {
        const { titleIcon, title, content, contentPositive, summary, condensedTitleIcon, condensedTitle, } = this.constructor;
        const badgeContent = content || this.content;
        const badgeSummary = summary || this.summary;
        const elmId = _.snakeCase(title || summary);
        return this.props.mode === BADGE_MODE.CONDENSED ? (_jsx(CondensedBadge, { elmId: elmId, title: condensedTitle || title || summary, iconName: condensedTitleIcon || titleIcon })) : (_jsxs("div", { className: cx('u-display-f', 'u-stretch', 'hoisted-badge'), "data-elm-id": `${elmId}_container`, children: [_jsx("div", { children: _jsx(Icon, { iconStyle: 'light', className: cx('hoisted-badge-icon'), name: titleIcon, "data-elm-id": `${elmId}_icon` }) }), _jsxs(Text, { children: [_jsxs("strong", { "data-elm-id": `${elmId}_label`, className: cx(contentPositive ? 'color-success' : 'color-error'), children: [badgeSummary, ":", ' '] }), _jsx("span", { "data-elm-id": `${elmId}_content`, children: badgeContent })] })] }));
    }
}
//# sourceMappingURL=fullWidthBadge.js.map